module.exports = __webpack_public_path__ + "static/media/Item 5.39d96d62.jpg";